import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomLogoutGuard } from './logout.guard';
import { CmsPageGuard, PageLayoutComponent, PageLayoutModule } from '@spartacus/storefront';

@NgModule({
  imports: [
    PageLayoutModule,
    RouterModule.forChild([
      {
        // @ts-ignore
        path: null,
        canActivate: [CustomLogoutGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'logout' },
      },
    ]),
  ],
})
export class CustomLogoutModule {}
